export default __webpack_public_path__ + "static/media/m3-black.2519532b.svg";